<div class="row p-4 py-0" *ngIf="gazeMap?.s">
  <div class="d-grid d-md-block">
    <span class="fw-bold me-2">{{ 'COMMON.DATE' | translate }}</span> {{ gazeMap.s.created_at_non_utc | date:'yyyy/MM/dd HH:mm' }}
    <span *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.shortTestID" class="fw-bold mx-2 me-2">{{
      'DATATABLE.COLUMN.ALIAS' |
      translate }}</span> <span *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.shortTestID">{{
      gazeMap!.s.alias }}</span>
    <div class="float-end">
      <div class="input-group">
        <label for="reference" class="col-sm-2 col-form-label fw-bold" [class]="!isExternalReportingEnabled ? 'me-3' : ''">{{ 'COMMON.REFERENCE' | translate }}</label>
        <input type="text" class="form-control" id="reference" [(ngModel)]="displayValue" (ngModelChange)="onInputChange()" [readonly]="privacity">
        <button *ngIf="user.profileId !== 2" type="button" class="btn btn-dark" (click)="save()"><img
            src="assets/images/icons/send.svg"> {{
          (isExternalReportingEnabled ? 'MIMESYS.SAVE_SEND_RESULT' : 'COMMON.SAVE') | translate }}</button>
        <!-- Add invisible placeholder button when main button is hidden -->
        <div *ngIf="user.profileId === 2" class="btn btn-dark" style="visibility: hidden; pointer-events: none;">
          <img src="assets/images/icons/send.svg"> {{ (isExternalReportingEnabled ? 'MIMESYS.SAVE_SEND_RESULT' : 'COMMON.SAVE') | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row p-4 pb-0">
  <div class="d-grid">
    <button *ngIf="hidden != undefined && user.profileId !== 2 " type="button" class="btn btn-outline-secondary me-2" data-bs-toggle="modal"
      [attr.data-bs-target]="'#confirmationModal-' + gazeMap?.s?.testId">
      <i class="bi bi-trash3"></i> {{ (hidden ? 'MIMESYS.RECOVER_RESULT' : 'MIMESYS.DELETE_RESULT') | translate }}
    </button>
    <hbo-confirmation-modal
      *ngIf="gazeMap?.s?.testId" [id]="gazeMap?.s?.testId" (confirm)="delete()"
      [message]="hidden ?  'COMMON.SURE_TO_CONTINUE_RESTORE' : 'COMMON.SURE_TO_CONTINUE'"
      [head]="hidden ?  'COMMON.WILL_BE_RESTORED' : 'COMMON.WILL_BE_DELETED'"
      >
    </hbo-confirmation-modal>

    <!-- <button *ngIf="hidden != undefined && user.profileId !== 2 " type="button" class="btn btn-outline-secondary me-2"
      (click)="delete()"><i class="bi bi-trash3">
      </i> {{ (hidden ? 'MIMESYS.RECOVER_RESULT' : 'MIMESYS.DELETE_RESULT') | translate }}
    </button> -->

    <button *ngIf="gazeMapService.currentGazeMapSettingsValue.settings?.ergoCorridorEnable && gazeMap?.l && gazeMap?.m && gazeMap?.s" type="button"
      class="btn btn-outline-secondary me-2 ergo-corridor" data-bs-toggle="modal"
      [attr.data-bs-target]="'#corridorModal'" (click)="initializeCorridor()">
      <div class="ico-corridor"></div>
      <span>{{ gazeMapService.currentGazeMapSettingsValue.settings?.ergoCorridorName ?? ('MIMESYS.CORRIDOR' | translate)
        }}</span>
    </button>
    <div>
      <!--<button type="button" class="btn btn-outline-secondary me-2" (click)="downloadCsv()"><i class="bi bi-download"></i> {{ 'MIMESYS.DOWNLOAD_CSV' | translate }}</button>-->
      <button type="button" class="btn btn-outline-secondary" (click)="setDownoladablePdf()"><i
          class="bi bi-download"></i>
        {{
        'COMMON.DOWNLOAD' | translate }}</button>
    </div>
  </div>
</div>

<!-- PROGRESSIVE -->
<div id="gaze-map-containter-to-pdf" class="row p-4" *ngIf="gazeMap?.l && gazeMap?.m && gazeMap?.s" [ngClass]="{'pdfStylingDiv':whileCreatingPdf}">
  <div class="col-12 to-pdf-extra-info">
    <div class="row">
      <div class="col-4">
        <div>Code:</div>
        <div>{{gazeMap!.m.testId}}</div>
        <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.shortTestID">Short Test ID:</div>
        <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.shortTestID">{{gazeMap!.m.alias}}</div>
      </div>
      <div class="col-4">
        <div>
          Date:</div>
        <div>{{gazeMap.s.created_at_non_utc | date:'yyyy/MM/dd HH:mm' }}</div>
      </div>
      <div class="col-4">
        <div>
          Reference:</div>
        <div>{{displayValue}}</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-4"
    [ngClass]="{'col-fusion':gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion'}">

    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' "
      class="gazeMap-fusion-container">
      <div class="gazeMap-fusion" style="position: absolute;">
        <span>Gaze Dynamics Map</span>
      </div>
    </div>
    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' "
      class="gazeMap-map gazeMap-map-office" alt="Gaze Map" style="visibility:hidden">
      <img src="assets/images/halo.png">
    </div>
    <div class="form-check form-switch form-switch-fusion"
      *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' && user.roleId === 1 && !whileCreatingPdf">
      <input class="form-check-input" type="checkbox" role="switch" id="viewRawData" [(ngModel)]="viewRawData">
      <label class="form-check-label" for="viewRawData">{{ 'MIMESYS.VIEW_RAW_DATA' | translate }}</label>
    </div>
    <h3 *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay !='Fusion'">
      {{ 'MIMESYS.FAR_PLANE' | translate }}</h3>
    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay !='Fusion' "
      class="gazeMap-map gazeMap-map-fusion" [style.background-image]="'url(' + gazeMap.l.imagen + ')'">
      <div class="concentric-circles gaze-map-grid">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="line-h-1"></div>
        <div class="line-h-2"></div>
        <div class="line-h-3"></div>
        <div class="line-h-4"></div>
        <div class="line-h-5"></div>
        <div class="line-h-6"></div>
        <div class="line-h-7"></div>
        <div class="line-h-8"></div>
        <div class="line-h-9"></div>
        <div class="line-h-10"></div>
        <div class="line-h-11"></div>
        <div class="line-h-12"></div>
        <div class="line-h-13"></div>
        <div class="line-h-14"></div>
        <div class="line-h-15"></div>
        <div class="line-v-1"></div>
        <div class="line-v-2"></div>
        <div class="line-v-3"></div>
        <div class="line-v-4"></div>
        <div class="line-v-5"></div>
        <div class="line-v-6"></div>
        <div class="line-v-7"></div>
        <div class="line-v-8"></div>
        <div class="line-v-9"></div>
        <div class="line-v-10"></div>
        <div class="line-v-11"></div>
        <div class="line-v-12"></div>
        <div class="line-v-13"></div>
        <div class="line-v-14"></div>
        <div class="line-v-15"></div>
        <!--<div class="circle"></div>
          <div class="circle"></div>-->
      </div>
      <!--<img src="assets/images/grid.svg" class="gaze-map-grid">-->
    </div>
    <div class="form-check form-switch my-4"
      *ngIf="user.roleId === 1 && !whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay !='Fusion'">
      <input class="form-check-input" type="checkbox" role="switch" id="viewRawData" [(ngModel)]="viewRawData">
      <label class="form-check-label" for="viewRawData">{{ 'MIMESYS.VIEW_RAW_DATA' | translate }}</label>
    </div>
    <h3 *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion'">
      {{ 'MIMESYS.FAR_PLANE' | translate }}</h3>
    <ul class="list-group list-group-flush"
      [ngClass]="{'list-group-no-admin':user.roleId != 1 || (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion'),'list-group-l':(user.roleId ==1 && !whileCreatingPdf)||user.roleId !=1 ,'list-group-creating-pdf':user.roleId !=1 || (user.roleId == 1 && whileCreatingPdf)}">
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.gazeType" class="list-group-item">
        <img src="assets/images/icons/gaze-type.svg">
        <span>{{
          'MIMESYS.GAZE_TYPE' |
          translate }}</span>
        <span class="float-end">{{ gazeMap.l.classification.tipo_mirada }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.amplitudeRatio" class="list-group-item">
        <img src="assets/images/icons/amplitude-ratio.svg">
        <span>{{
          'MIMESYS.AMPLITUDE_RATIO' | translate }}</span>
        <span class="float-end">{{ gazeMap.l.classification.amplitud }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.maxFrequencyVector" class="list-group-item">
        <img src="assets/images/icons/max-freq-vector.svg">
        <span>{{
          'MIMESYS.MAX_FREQUENCY_VECTOR' | translate
          }}</span>
        <span class="float-end">{{ gazeMap.l.classification.frequency }}</span>
      </li>
      <li class="list-group-item" *ngIf="viewRawData">
        <table class="table table-borderless">
          <tbody>
            <tr>
              <td>{{ 'MIMESYS.X_MIN' | translate }}</td>
              <td>{{ gazeMap.l.xMin }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_MED' | translate }}</td>
              <td>{{ gazeMap.l.xMed }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_MAX' | translate }}</td>
              <td>{{ gazeMap.l.xMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.l.xCoordMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MIN' | translate }}</td>
              <td>{{ gazeMap.l.yMin }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MED' | translate }}</td>
              <td>{{ gazeMap.l.yMed }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MAX' | translate }}</td>
              <td>{{ gazeMap.l.yMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.l.yCoordMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.ANGULO_HORIZONTE' | translate }}</td>
              <td>{{ gazeMap.l.anguloHorizonte }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.ANGULO_PLANO' | translate }}</td>
              <td>{{ gazeMap.l.anguloPlano }}</td>
            </tr>
          </tbody>
        </table>
      </li>
      <li *ngIf="!viewRawData && gazeMapService.currentGazeMapSettingsValue.settings!.diagnostic" class="list-group-item">
        <img src="assets/images/icons/diagnostic.svg">
        <span>{{
          'MIMESYS.DIAGNOSTIC' | translate }}</span>
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.l.classification.diagnostic }}</p>
      </li>
    </ul>
    <div
      *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' && gazeMapService.currentGazeMapSettingsValue.settings!.additionalMapsDisplay =='All'"
      class="gazeMap-map gazeMap-map-fusion" [style.background-image]="'url(' + gazeMap.l.imagen + ')'">
      <div class="concentric-circles gaze-map-grid">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="line-h-1"></div>
        <div class="line-h-2"></div>
        <div class="line-h-3"></div>
        <div class="line-h-4"></div>
        <div class="line-h-5"></div>
        <div class="line-h-6"></div>
        <div class="line-h-7"></div>
        <div class="line-h-8"></div>
        <div class="line-h-9"></div>
        <div class="line-h-10"></div>
        <div class="line-h-11"></div>
        <div class="line-h-12"></div>
        <div class="line-h-13"></div>
        <div class="line-h-14"></div>
        <div class="line-h-15"></div>
        <div class="line-v-1"></div>
        <div class="line-v-2"></div>
        <div class="line-v-3"></div>
        <div class="line-v-4"></div>
        <div class="line-v-5"></div>
        <div class="line-v-6"></div>
        <div class="line-v-7"></div>
        <div class="line-v-8"></div>
        <div class="line-v-9"></div>
        <div class="line-v-10"></div>
        <div class="line-v-11"></div>
        <div class="line-v-12"></div>
        <div class="line-v-13"></div>
        <div class="line-v-14"></div>
        <div class="line-v-15"></div>
        <!--<div class="circle"></div>
          <div class="circle"></div>-->
      </div>
      <!--<img src="assets/images/grid.svg" class="gaze-map-grid">-->
    </div>
  </div>
  <div class="col-12 col-md-4"
    [ngClass]="{'col-fusion':gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion'}">
    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' "
      class="gazeMap-map gazeMap-map-office" alt="Gaze Map"
      [style.background-image]="'url(' + gazeMap.common.image + ')'">
      <img src="assets/images/halo.png">
    </div>
    <div class="form-check form-switch form-switch-fusion"
      *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' && user.roleId === 1 && !whileCreatingPdf">

    </div>
    <h3 *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay !='Fusion'">
      {{ 'MIMESYS.INTERMEDIATE_PLANE' | translate }}</h3>
    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay !='Fusion'"
      class="gazeMap-map gazeMap-map-fusion" [style.background-image]="'url(' + gazeMap.m.imagen + ')'">
      <div class="concentric-circles gaze-map-grid">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="line-h-1"></div>
        <div class="line-h-2"></div>
        <div class="line-h-3"></div>
        <div class="line-h-4"></div>
        <div class="line-h-5"></div>
        <div class="line-h-6"></div>
        <div class="line-h-7"></div>
        <div class="line-h-8"></div>
        <div class="line-h-9"></div>
        <div class="line-h-10"></div>
        <div class="line-h-11"></div>
        <div class="line-h-12"></div>
        <div class="line-h-13"></div>
        <div class="line-h-14"></div>
        <div class="line-h-15"></div>
        <div class="line-v-1"></div>
        <div class="line-v-2"></div>
        <div class="line-v-3"></div>
        <div class="line-v-4"></div>
        <div class="line-v-5"></div>
        <div class="line-v-6"></div>
        <div class="line-v-7"></div>
        <div class="line-v-8"></div>
        <div class="line-v-9"></div>
        <div class="line-v-10"></div>
        <div class="line-v-11"></div>
        <div class="line-v-12"></div>
        <div class="line-v-13"></div>
        <div class="line-v-14"></div>
        <div class="line-v-15"></div>
        <!--<div class="circle"></div>
          <div class="circle"></div>-->
      </div>
      <!--<img src="assets/images/grid.svg" class="gaze-map-grid">-->
    </div>
    <h3 *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion'">
      {{ 'MIMESYS.INTERMEDIATE_PLANE' | translate }}</h3>
    <ul class="list-group list-group-flush"
      [ngClass]="{'list-group-no-admin':user.roleId != 1,'list-group-creating-pdf':user.roleId != 1 || (user.roleId == 1 && whileCreatingPdf),'list-group-fusion':gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion'}">
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.gazeType" class="list-group-item">
        <img src="assets/images/icons/gaze-type.svg">
        <span>{{
          'MIMESYS.GAZE_TYPE' |
          translate }}</span>
        <span class="float-end">{{ gazeMap.m.classification.tipo_mirada }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.amplitudeRatio" class="list-group-item">
        <img src="assets/images/icons/amplitude-ratio.svg">
        <span>{{
          'MIMESYS.AMPLITUDE_RATIO' | translate }}</span>
        <span class="float-end">{{ gazeMap.m.classification.amplitud }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.maxFrequencyVector" class="list-group-item">
        <img src="assets/images/icons/max-freq-vector.svg">
        <span>{{
          'MIMESYS.MAX_FREQUENCY_VECTOR' | translate
          }}</span>
        <span class="float-end">{{ gazeMap.m.classification.frequency }}</span>
      </li>
      <li class="list-group-item" *ngIf="viewRawData">
        <table class="table table-borderless">
          <tbody>
            <tr>
              <td>{{ 'MIMESYS.X_MIN' | translate }}</td>
              <td>{{ gazeMap.m.xMin }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_MED' | translate }}</td>
              <td>{{ gazeMap.m.xMed }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_MAX' | translate }}</td>
              <td>{{ gazeMap.m.xMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.m.xCoordMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MIN' | translate }}</td>
              <td>{{ gazeMap.m.yMin }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MED' | translate }}</td>
              <td>{{ gazeMap.m.yMed }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MAX' | translate }}</td>
              <td>{{ gazeMap.m.yMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.m.yCoordMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.ANGULO_HORIZONTE' | translate }}</td>
              <td>{{ gazeMap.m.anguloHorizonte }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.ANGULO_PLANO' | translate }}</td>
              <td>{{ gazeMap.m.anguloPlano }}</td>
            </tr>
          </tbody>
        </table>
      </li>
      <li *ngIf="!viewRawData && gazeMapService.currentGazeMapSettingsValue.settings!.diagnostic" class="list-group-item">
        <img src="assets/images/icons/diagnostic.svg">
        <span>{{
          'MIMESYS.DIAGNOSTIC' | translate }}</span>
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.m.classification.diagnostic }}</p>
      </li>
    </ul>
    <div
      *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' && gazeMapService.currentGazeMapSettingsValue.settings!.additionalMapsDisplay =='All'"
      class="gazeMap-map gazeMap-map-fusion" [style.background-image]="'url(' + gazeMap.m.imagen + ')'">
      <div class="concentric-circles gaze-map-grid">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="line-h-1"></div>
        <div class="line-h-2"></div>
        <div class="line-h-3"></div>
        <div class="line-h-4"></div>
        <div class="line-h-5"></div>
        <div class="line-h-6"></div>
        <div class="line-h-7"></div>
        <div class="line-h-8"></div>
        <div class="line-h-9"></div>
        <div class="line-h-10"></div>
        <div class="line-h-11"></div>
        <div class="line-h-12"></div>
        <div class="line-h-13"></div>
        <div class="line-h-14"></div>
        <div class="line-h-15"></div>
        <div class="line-v-1"></div>
        <div class="line-v-2"></div>
        <div class="line-v-3"></div>
        <div class="line-v-4"></div>
        <div class="line-v-5"></div>
        <div class="line-v-6"></div>
        <div class="line-v-7"></div>
        <div class="line-v-8"></div>
        <div class="line-v-9"></div>
        <div class="line-v-10"></div>
        <div class="line-v-11"></div>
        <div class="line-v-12"></div>
        <div class="line-v-13"></div>
        <div class="line-v-14"></div>
        <div class="line-v-15"></div>
        <!--<div class="circle"></div>
          <div class="circle"></div>-->
      </div>
      <!--<img src="assets/images/grid.svg" class="gaze-map-grid">-->
    </div>
  </div>
  <div class="col-12 col-md-4"
    [ngClass]="{'col-fusion':gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion'}">
    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' "
      class="gazeMap-map gazeMap-map-office" alt="Gaze Map" style="visibility: hidden;">
      <img src="assets/images/halo.png">
    </div>
    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' "
      class="gazeMap-fusion-container">
      <div class="col-fusion-list">
        <div>{{ 'MIMESYS.FAR_DISTANCE' | translate}}</div>
        <div>{{ 'MIMESYS.INTERMEDIATE_DISTANCE' | translate}}</div>
        <div>{{ 'MIMESYS.NEAR_DISTANCE' | translate}}</div>
      </div>
    </div>
    <div class="form-check form-switch form-switch-fusion"
      *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' && user.roleId === 1 && !whileCreatingPdf">

    </div>
    <h3 *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay !='Fusion'">
      {{ 'MIMESYS.NEAR_PLANE' | translate }}</h3>
    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay !='Fusion'"
      class="gazeMap-map gazeMap-map-fusion" [style.background-image]="'url(' + gazeMap.s.imagen + ')'">
      <div class="concentric-circles gaze-map-grid">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="line-h-1"></div>
        <div class="line-h-2"></div>
        <div class="line-h-3"></div>
        <div class="line-h-4"></div>
        <div class="line-h-5"></div>
        <div class="line-h-6"></div>
        <div class="line-h-7"></div>
        <div class="line-h-8"></div>
        <div class="line-h-9"></div>
        <div class="line-h-10"></div>
        <div class="line-h-11"></div>
        <div class="line-h-12"></div>
        <div class="line-h-13"></div>
        <div class="line-h-14"></div>
        <div class="line-h-15"></div>
        <div class="line-v-1"></div>
        <div class="line-v-2"></div>
        <div class="line-v-3"></div>
        <div class="line-v-4"></div>
        <div class="line-v-5"></div>
        <div class="line-v-6"></div>
        <div class="line-v-7"></div>
        <div class="line-v-8"></div>
        <div class="line-v-9"></div>
        <div class="line-v-10"></div>
        <div class="line-v-11"></div>
        <div class="line-v-12"></div>
        <div class="line-v-13"></div>
        <div class="line-v-14"></div>
        <div class="line-v-15"></div>
        <!--<div class="circle"></div>
          <div class="circle"></div>-->
      </div>
      <!--<img src="assets/images/grid.svg" class="gaze-map-grid">-->
    </div>
    <h3 *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion'">
      {{ 'MIMESYS.NEAR_PLANE' | translate }}</h3>
    <ul class="list-group list-group-flush"
      [ngClass]="{'list-group-no-admin':user.roleId != 1,'list-group-creating-pdf':user.roleId != 1 || (user.roleId == 1 && whileCreatingPdf),'list-group-fusion':gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion'}">
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.gazeType" class="list-group-item">
        <img src="assets/images/icons/gaze-type.svg">
        <span>{{
          'MIMESYS.GAZE_TYPE' |
          translate }}</span>
        <span class="float-end">{{ gazeMap.s.classification.tipo_mirada }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.amplitudeRatio" class="list-group-item">
        <img src="assets/images/icons/amplitude-ratio.svg">
        <span>{{
          'MIMESYS.AMPLITUDE_RATIO' | translate }}</span>
        <span class="float-end">{{ gazeMap.s.classification.amplitud }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.maxFrequencyVector" class="list-group-item">
        <img src="assets/images/icons/max-freq-vector.svg">
        <span>{{
          'MIMESYS.MAX_FREQUENCY_VECTOR' | translate
          }}</span>
        <span class="float-end">{{ gazeMap.s.classification.frequency }}</span>
      </li>
      <li class="list-group-item" *ngIf="viewRawData">
        <table class="table table-borderless">
          <tbody>
            <tr>
              <td>{{ 'MIMESYS.X_MIN' | translate }}</td>
              <td>{{ gazeMap.s.xMin }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_MED' | translate }}</td>
              <td>{{ gazeMap.s.xMed }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_MAX' | translate }}</td>
              <td>{{ gazeMap.s.xMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.s.xCoordMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MIN' | translate }}</td>
              <td>{{ gazeMap.s.yMin }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MED' | translate }}</td>
              <td>{{ gazeMap.s.yMed }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MAX' | translate }}</td>
              <td>{{ gazeMap.s.yMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.s.yCoordMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.ANGULO_HORIZONTE' | translate }}</td>
              <td>{{ gazeMap.s.anguloHorizonte }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.ANGULO_PLANO' | translate }}</td>
              <td>{{ gazeMap.s.anguloPlano }}</td>
            </tr>
          </tbody>
        </table>
      </li>
      <li *ngIf="!viewRawData && gazeMapService.currentGazeMapSettingsValue.settings!.diagnostic" class="list-group-item">
        <img src="assets/images/icons/diagnostic.svg">
        <span>{{
          'MIMESYS.DIAGNOSTIC' | translate }}</span>
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.s.classification.diagnostic }}</p>
      </li>
    </ul>
    <div
      *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' && gazeMapService.currentGazeMapSettingsValue.settings!.additionalMapsDisplay =='All'"
      class="gazeMap-map gazeMap-map-fusion" [style.background-image]="'url(' + gazeMap.s.imagen + ')'">
      <div class="concentric-circles gaze-map-grid">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="line-h-1"></div>
        <div class="line-h-2"></div>
        <div class="line-h-3"></div>
        <div class="line-h-4"></div>
        <div class="line-h-5"></div>
        <div class="line-h-6"></div>
        <div class="line-h-7"></div>
        <div class="line-h-8"></div>
        <div class="line-h-9"></div>
        <div class="line-h-10"></div>
        <div class="line-h-11"></div>
        <div class="line-h-12"></div>
        <div class="line-h-13"></div>
        <div class="line-h-14"></div>
        <div class="line-h-15"></div>
        <div class="line-v-1"></div>
        <div class="line-v-2"></div>
        <div class="line-v-3"></div>
        <div class="line-v-4"></div>
        <div class="line-v-5"></div>
        <div class="line-v-6"></div>
        <div class="line-v-7"></div>
        <div class="line-v-8"></div>
        <div class="line-v-9"></div>
        <div class="line-v-10"></div>
        <div class="line-v-11"></div>
        <div class="line-v-12"></div>
        <div class="line-v-13"></div>
        <div class="line-v-14"></div>
        <div class="line-v-15"></div>
        <!--<div class="circle"></div>
          <div class="circle"></div>-->
      </div>
      <!--<img src="assets/images/grid.svg" class="gaze-map-grid">-->
    </div>
  </div>
</div>

<!-- OFFICE -->
<!-- PDF office-->
<div id="gaze-map-containter-to-pdf" class="row p-4" *ngIf="gazeMap && !gazeMap.l"
  [ngClass]="{'pdfStylingDiv':whileCreatingPdf}">
  <div class="col-12 to-pdf-extra-info">
    <div class="row">
      <div class="col-4">
        <div>Code:</div>
        <div>{{gazeMap!.m.testId}}</div>
        <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.shortTestID">Short Test ID:</div>
        <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.shortTestID">{{gazeMap!.m.alias}}</div>
      </div>
      <div class="col-4">
        <div>
          Date:</div>
        <div>{{gazeMap!.s.created_at_non_utc | date:'yyyy/MM/dd HH:mm' }}</div>
      </div>
      <div class="col-4">
        <div>
          Reference:</div>
        <div>{{displayValue}}</div>
      </div>
    </div>
  </div>
  <div class="col-6">
    <h3>
      {{ 'COMMON.GAZE_TITLE' | translate }}</h3>
    <div class="gazeMap-map gazeMap-map-office" [style.background-image]="'url(' + gazeMap.common.image + ')'"
      alt="Gaze Map">
      <img src="assets/images/halo.png" class="gaze-map-halo">
    </div>

    <div class="form-check form-switch my-4" *ngIf="user.roleId === 1 && !whileCreatingPdf">
      <input class="form-check-input" type="checkbox" role="switch" id="viewRawData" [(ngModel)]="viewRawData">
      <label class="form-check-label" for="viewRawData">{{ 'MIMESYS.VIEW_RAW_DATA' | translate }}</label>
    </div>

    <ul class="list-group list-group-flush"
      [ngClass]="{'list-group-office':(user.roleId==1 && !whileCreatingPdf) || user.roleId!=1}">
      <li class="list-group-item">
        <img src="assets/images/icons/gaze-type.svg">
        <span>{{
          'MIMESYS.GAZE_TYPE' |
          translate }}</span>
        <span class="float-end">{{
          gazeMap.common.classification.tipo_mirada }}</span>
      </li>
      <li class="list-group-item">
        <img src="assets/images/icons/amplitude-ratio.svg">
        <span>{{
          'MIMESYS.VERTICAL_FLECTION_RATIO' | translate
          }}</span>
        <span class="float-end">{{ gazeMap.common.classification.vertical_flection_ratio }}</span>
      </li>
      <li class="list-group-item"><!--autoplay de video-->
        <img src="assets/images/icons/max-freq-vector.svg">
        <span>{{
          'MIMESYS.MAX_FREQUENCY_VECTOR' | translate
          }}</span>
        <span class="float-end">{{ gazeMap.common.classification.frequency }}</span>
      </li>
      <li class="list-group-item" *ngIf="viewRawData">
        <table class="table table-borderless">
          <tbody>
            <tr>
              <td>{{ 'MIMESYS.X_MIN' | translate }}</td>
              <td>{{ gazeMap.m.xMin }}</td>
              <td>{{ 'MIMESYS.X_MIN' | translate }}</td>
              <td>{{ gazeMap.s.xMin }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_MED' | translate }}</td>
              <td>{{ gazeMap.m.xMed }}</td>
              <td>{{ 'MIMESYS.X_MED' | translate }}</td>
              <td>{{ gazeMap.s.xMed }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_MAX' | translate }}</td>
              <td>{{ gazeMap.m.xMax }}</td>
              <td>{{ 'MIMESYS.X_MAX' | translate }}</td>
              <td>{{ gazeMap.s.xMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.m.xCoordMax }}</td>
              <td>{{ 'MIMESYS.X_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.s.xCoordMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MIN' | translate }}</td>
              <td>{{ gazeMap.m.yMin }}</td>
              <td>{{ 'MIMESYS.Y_MIN' | translate }}</td>
              <td>{{ gazeMap.s.yMin }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MED' | translate }}</td>
              <td>{{ gazeMap.m.yMed }}</td>
              <td>{{ 'MIMESYS.Y_MED' | translate }}</td>
              <td>{{ gazeMap.s.yMed }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MAX' | translate }}</td>
              <td>{{ gazeMap.m.yMax }}</td>
              <td>{{ 'MIMESYS.Y_MAX' | translate }}</td>
              <td>{{ gazeMap.s.yMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.m.yCoordMax }}</td>
              <td>{{ 'MIMESYS.Y_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.s.yCoordMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.ANGULO_HORIZONTE' | translate }}</td>
              <td>{{ gazeMap.m.anguloHorizonte }}</td>
              <td>{{ 'MIMESYS.ANGULO_HORIZONTE' | translate }}</td>
              <td>{{ gazeMap.s.anguloHorizonte }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.ANGULO_PLANO' | translate }}</td>
              <td>{{ gazeMap.m.anguloPlano }}</td>
              <td>{{ 'MIMESYS.ANGULO_PLANO' | translate }}</td>
              <td>{{ gazeMap.s.anguloPlano }}</td>
            </tr>
          </tbody>
        </table>
      </li>
      <li class="list-group-item" *ngIf="!viewRawData">
        <!-- && gazeMapService.currentGazeMapSettingsValue.settings!.diagnostic-->
        <img src="assets/images/icons/diagnostic.svg">
        <span>{{
          'MIMESYS.DIAGNOSTIC' | translate }}</span>
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.common.classification.diagnostic }}</p>
      </li>
    </ul>
  </div>
  <div class="col-6">
    <h3>
      {{ 'COMMON.WORKSPACE_TITLE' | translate }}</h3>
    <div class="gazeMap-map gaze-map-desktop " [ngClass]="{'gaze-map-desktop-non-admin':user.role?.id != 1}"
      alt="Gaze Map" [style.background-image]="'url(' + transform(lensOfficePrefix + gazeMap.common.desktop_image) + ')'">
    </div>
    <ul class="list-group list-group-office list-group-flush">
      <li class="list-group-item">
        <img src="assets/images/icons/diagnostic.svg">
        <span>{{
          'MIMESYS.ERGONOMY' | translate }}</span>
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.common.classification.ergonomy }}</p>
      </li>
    </ul>
  </div>
</div>
<!--- pdf bi-fold- -->

<!-- Single Vision (svision) category -->
<div id="gaze-map-containter-to-pdf" class="row p-4"
     *ngIf="gazeMap && gazeMap.l && gazeMap.s && gazeMap.s.aplicacion_name=='svision'"
     [ngClass]="{'pdfStylingDiv':whileCreatingPdf}">
  <div class="col-12 to-pdf-extra-info">
    <div class="row">
      <div class="col-4">
        <div>Code: {{gazeMap!.s.testId}}</div>
        <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.shortTestID">Short Test ID: {{gazeMap!.s.alias}}</div>
      </div>
      <div class="col-4">
        <div>Date: {{gazeMap.s.created_at_non_utc | date:'yyyy/mm/dd HH:mm' }}</div>
      </div>
      <div class="col-4">
        <div>Reference: {{displayValue}}</div>
      </div>
    </div>
  </div>
  <!-- Centered fusioned gaze map -->
  <div class="col-12 d-flex justify-content-center mb-4">
    <div class="svision-map-container">
      <div class="gazeMap-map gazeMap-map-svision"
           [style.background-image]="'url(' + gazeMap.common.image + ')'"
           alt="Single Vision Gaze Map">
        <img src="assets/images/halo.png" class="gaze-map-halo-svision">
      </div>
      <div class="gazeMap-fusion-container-svision">
        <div class="col-fusion-list-svision">
          <div>{{ 'MIMESYS.FAR_DISTANCE' | translate}}</div>
          <div>{{ 'MIMESYS.NEAR_DISTANCE' | translate}}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Two columns below: Far plane and Near plane -->
  <div class="col-6">
    <div class="form-check form-switch mb-3" *ngIf="user.roleId === 1 && !whileCreatingPdf">
      <input class="form-check-input" type="checkbox" role="switch" id="viewRawDataSvision" [(ngModel)]="viewRawData">
      <label class="form-check-label" for="viewRawDataSvision">{{ 'MIMESYS.VIEW_RAW_DATA' | translate }}</label>
    </div>
    <h3>{{ 'MIMESYS.FAR_PLANE' | translate }}</h3>

    <ul class="list-group list-group-flush"
        [ngClass]="{'list-group-office':(user.roleId==1 && !whileCreatingPdf) || user.roleId!=1}">

      <li class="list-group-item">
        <img src="assets/images/icons/gaze-type.svg">
        <span>{{ 'MIMESYS.GAZE_TYPE' | translate }}</span>
        <span class="float-end">{{ gazeMap.l.classification.tipo_mirada }}</span>
      </li>

      <li class="list-group-item">
        <img src="assets/images/icons/amplitude-ratio.svg">
        <span>{{ 'MIMESYS.AMPLITUDE_RATIO' | translate }}</span>
        <span class="float-end">{{ gazeMap.l.classification.amplitud }}</span>
      </li>

      <li class="list-group-item">
        <img src="assets/images/icons/max-freq-vector.svg">
        <span>{{ 'MIMESYS.MAX_FREQUENCY_VECTOR' | translate }}</span>
        <span class="float-end">{{ gazeMap.l.classification.frequency }}</span>
      </li>

      <li class="list-group-item" *ngIf="viewRawData">
        <table class="table table-borderless">
          <tbody>
            <tr>
              <td>{{ 'MIMESYS.X_MIN' | translate }}</td>
              <td>{{ gazeMap.l.xMin }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_MED' | translate }}</td>
              <td>{{ gazeMap.l.xMed }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_MAX' | translate }}</td>
              <td>{{ gazeMap.l.xMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.l.xCoordMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MIN' | translate }}</td>
              <td>{{ gazeMap.l.yMin }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MED' | translate }}</td>
              <td>{{ gazeMap.l.yMed }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MAX' | translate }}</td>
              <td>{{ gazeMap.l.yMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.l.yCoordMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.ANGULO_HORIZONTE' | translate }}</td>
              <td>{{ gazeMap.l.anguloHorizonte }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.ANGULO_PLANO' | translate }}</td>
              <td>{{ gazeMap.l.anguloPlano }}</td>
            </tr>
          </tbody>
        </table>
      </li>

      <li class="list-group-item" *ngIf="!viewRawData">
        <img src="assets/images/icons/diagnostic.svg">
        <span>{{ 'MIMESYS.DIAGNOSTIC' | translate }}</span>
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.l.classification.diagnostic }}</p>
      </li>
    </ul>
  </div>

  <div class="col-6">
    <!-- invisible placeholder to make up for view data switch space so that far and near plane are at the same height -->
    <div class="form-check form-switch mb-3" *ngIf="user.roleId === 1 && !whileCreatingPdf" style="visibility: hidden;">
      <input class="form-check-input" type="checkbox" role="switch">
      <label class="form-check-label">&nbsp;</label>
    </div>
    <h3>{{ 'MIMESYS.NEAR_PLANE' | translate }}</h3>

    <ul class="list-group list-group-flush"
        [ngClass]="{'list-group-office':(user.roleId==1 && !whileCreatingPdf) || user.roleId!=1}">

      <li class="list-group-item">
        <img src="assets/images/icons/gaze-type.svg">
        <span>{{ 'MIMESYS.GAZE_TYPE' | translate }}</span>
        <span class="float-end">{{ gazeMap.s.classification.tipo_mirada }}</span>
      </li>

      <li class="list-group-item">
        <img src="assets/images/icons/amplitude-ratio.svg">
        <span>{{ 'MIMESYS.AMPLITUDE_RATIO' | translate }}</span>
        <span class="float-end">{{ gazeMap.s.classification.amplitud }}</span>
      </li>

      <li class="list-group-item">
        <img src="assets/images/icons/max-freq-vector.svg">
        <span>{{ 'MIMESYS.MAX_FREQUENCY_VECTOR' | translate }}</span>
        <span class="float-end">{{ gazeMap.s.classification.frequency }}</span>
      </li>

      <li class="list-group-item" *ngIf="viewRawData">
        <table class="table table-borderless">
          <tbody>
            <tr>
              <td>{{ 'MIMESYS.X_MIN' | translate }}</td>
              <td>{{ gazeMap.s.xMin }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_MED' | translate }}</td>
              <td>{{ gazeMap.s.xMed }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_MAX' | translate }}</td>
              <td>{{ gazeMap.s.xMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.X_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.s.xCoordMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MIN' | translate }}</td>
              <td>{{ gazeMap.s.yMin }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MED' | translate }}</td>
              <td>{{ gazeMap.s.yMed }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_MAX' | translate }}</td>
              <td>{{ gazeMap.s.yMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.Y_COORD_MAX' | translate }}</td>
              <td>{{ gazeMap.s.yCoordMax }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.ANGULO_HORIZONTE' | translate }}</td>
              <td>{{ gazeMap.s.anguloHorizonte }}</td>
            </tr>
            <tr>
              <td>{{ 'MIMESYS.ANGULO_PLANO' | translate }}</td>
              <td>{{ gazeMap.s.anguloPlano }}</td>
            </tr>
          </tbody>
        </table>
      </li>

      <li class="list-group-item" *ngIf="!viewRawData">
        <img src="assets/images/icons/diagnostic.svg">
        <span>{{ 'MIMESYS.DIAGNOSTIC' | translate }}</span>
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.s.classification.diagnostic }}</p>
      </li>
    </ul>
  </div>
</div>

<div id="gaze-map-containter-to-pdf-bi-fold-brochure" class="row p-4"
  *ngIf="gazeMap?.l && gazeMap?.m && gazeMap?.s && gazeMapService.currentGazeMapSettingsValue?.settings!.template=='Bi-fold-brochure'"
  [ngClass]="{'pdfStylingDiv':whileCreatingPdf}">
  <div id="gaze-map-containter-to-pdf-extra-info">
    <ul
      [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      <li
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <div
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          Code:</div>
        <div>{{gazeMap!.m.testId}}</div>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.shortTestID"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <div
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          Short Test ID:</div>
        <div>{{gazeMap!.m.alias}}</div>
      </li>
      <li
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <div
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          Date:</div>
        <div>{{gazeMap.s.created_at_non_utc | date:'yyyy/MM/dd HH:mm' }}</div>
      </li>
      <li
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <div
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          Reference:</div>
        <div>{{displayValue}}</div>
      </li>
    </ul>
  </div>
  <div class="col-12 col-md-3">
    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay !='Fusion'" class="gazeMap-map">
      <img src="assets/images/grid.svg" class="gaze-map-grid-hidden">
    </div>
    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' "
      class="gazeMap-map gazeMap-map-office" alt="Gaze Map" style="visibility:hidden">
      <img src="assets/images/halo.png">
    </div>
    <h3
      [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      {{''}}
    </h3>
    <ul class="list-group list-group-flush"
      [ngClass]="{'list-group-l':!whileCreatingPdf && user.roleId ==1,'list-group-creating-pdf':whileCreatingPdf}"
      [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.gazeType" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <!--<img src="assets/images/icons/gaze-type.svg">-->
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="22" viewBox="6 0 22 22" fill="none">
          <path d="M11.7091 0.5L1.5 10.952L11.7091 21.404"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path
            d="M9.22852 2.89722C11.2572 5.007 12.3912 7.82624 12.3912 10.7602C12.3912 13.6941 11.2572 16.5134 9.22852 18.6232"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path
            d="M17.2925 0.5C19.9921 3.32222 21.4999 7.0851 21.4999 11C21.4999 14.9148 19.9921 18.6777 17.2925 21.4999"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path
            d="M12.2811 13.445C11.6738 13.445 11.0913 13.2025 10.6619 12.771C10.2325 12.3394 9.99121 11.754 9.99121 11.1436C9.99121 10.5333 10.2325 9.94793 10.6619 9.51634C11.0913 9.08475 11.6738 8.84229 12.2811 8.84229"
            [ngStyle]="{'fill': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}" />
          <path d="M17.2925 18.8152V21.5001H19.7732"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path d="M19.7732 0.5H17.2925V3.08903"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
        </svg>
        <span
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">{{
          'MIMESYS.GAZE_TYPE' |
          translate }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.amplitudeRatio" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="4 0 24 24" fill="none">
          <g clip-path="url(#clip0_1137_87727)">
            <path
              d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" />
            <path
              d="M18.7999 20.5999C11.1999 19.9999 8.4999 16.9999 3.3999 18.7999C3.9999 11.1999 6.9999 8.4999 5.1999 3.3999C12.7999 3.9999 15.4999 6.9999 20.5999 5.1999C19.9999 12.7999 16.9999 15.4999 18.7999 20.5999Z"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-linejoin="round" />
            <path d="M12.0002 1C18.2002 14.5 5.80024 9.5 12.0002 23"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" />
            <path d="M1 12C14.5 5.79999 9.5 18.2 23 12"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" />
          </g>
          <defs>
            <clipPath id="clip0_1137_87727">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">{{
          'MIMESYS.AMPLITUDE_RATIO' | translate }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.maxFrequencyVector" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <!--<img src="assets/images/icons/max-freq-vector.svg">-->
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="4 0 24 24" fill="none">
          <path
            d="M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path d="M12 1V23"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path d="M1 12H23"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path d="M14.7002 9.3999H9.2002V14.8999H14.7002V9.3999Z"
            [ngStyle]="{'fill': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}" />
        </svg>
        <span
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">{{
          'MIMESYS.MAX_FREQUENCY_VECTOR' | translate
          }}</span>
      </li>
      <li *ngIf="!viewRawData && gazeMapService.currentGazeMapSettingsValue.settings!.diagnostic" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <!--<img src="assets/images/icons/diagnostic.svg">-->
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="4 0 24 24" fill="none">
          <g clip-path="url(#clip0_1137_87723)">
            <path d="M1 10.9H3.6L6.2 4.30005L9.7 17L11.1 10.6H21"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M19.1 1H2.9C1.85066 1 1 1.85066 1 2.9V19.1C1 20.1493 1.85066 21 2.9 21H19.1C20.1493 21 21 20.1493 21 19.1V2.9C21 1.85066 20.1493 1 19.1 1Z"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" stroke-linecap="round" />
            <path
              d="M19 24C21.7614 24 24 21.7614 24 19C24 16.2386 21.7614 14 19 14C16.2386 14 14 16.2386 14 19C14 21.7614 16.2386 24 19 24Z"
              [ngStyle]="{'fill': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}" />
            <path d="M16.7002 18.9999L18.2002 20.8999L21.3002 17.3999" stroke="white" stroke-miterlimit="10"
              stroke-linecap="round" />
          </g>
          <defs>
            <clipPath id="clip0_1137_87723">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">{{
          'MIMESYS.DIAGNOSTIC' | translate }}</span>
      </li>
    </ul>
  </div>
  <div class="col-12 col-md-3"
    [ngClass]="{'col-fusion':gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion'}">

    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay !='Fusion'" class="gazeMap-map"
      [style.background-image]="'url(' + gazeMap.l.imagen + ')'">
      <img src="assets/images/grid.svg" class="gaze-map-grid-hidden">
    </div>
    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' "
      class="gazeMap-map gazeMap-map-office" alt="Gaze Map"
      [style.background-image]="'url(' + gazeMap.common.image + ')'">
      <img src="assets/images/halo.png">
    </div>
    <h3
      [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      {{ 'MIMESYS.FAR_PLANE' | translate }}</h3>
    <ul class="list-group list-group-flush"
      [ngClass]="{'list-group-l':!whileCreatingPdf  && user.roleId ==1,'list-group-creating-pdf':whileCreatingPdf}"
      [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.l.classification.tipo_mirada }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.amplitudeRatio" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.l.classification.amplitud }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.maxFrequencyVector" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.l.classification.frequency }}</span>
      </li>
      <li *ngIf="!viewRawData && gazeMapService.currentGazeMapSettingsValue.settings!.diagnostic" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.l.classification.diagnostic }}</p>
      </li>
    </ul>
    <div
      *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' && gazeMapService.currentGazeMapSettingsValue.settings!.additionalMapsDisplay =='All'"
      class="gazeMap-map gazeMap-map-fusion" [style.background-image]="'url(' + gazeMap.l.imagen + ')'">
      <img src="assets/images/grid.svg" class="gaze-map-grid-hidden">
    </div>
  </div>
  <div class="col-12 col-md-3"
    [ngClass]="{'col-fusion':gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion'}">

    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay !='Fusion'" class="gazeMap-map"
      [style.background-image]="'url(' + gazeMap.m.imagen + ')'">
      <img src="assets/images/grid.svg" class="gaze-map-grid-hidden">
    </div>
    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' "
      class="gazeMap-map gazeMap-map-office" alt="Gaze Map" style="visibility:hidden">
      <img src="assets/images/halo.png">
    </div>
    <h3
      [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      {{ 'MIMESYS.INTERMEDIATE_PLANE' | translate }}</h3>
    <ul class="list-group list-group-flush" [ngClass]="{'list-group-creating-pdf':whileCreatingPdf}"
      [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.gazeType" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.m.classification.tipo_mirada }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.amplitudeRatio" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.m.classification.amplitud }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.maxFrequencyVector" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.m.classification.frequency }}</span>
      </li>
      <li *ngIf="!viewRawData && gazeMapService.currentGazeMapSettingsValue.settings!.diagnostic" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.m.classification.diagnostic }}</p>
      </li>
    </ul>
    <div
      *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' && gazeMapService.currentGazeMapSettingsValue.settings!.additionalMapsDisplay =='All'"
      class="gazeMap-map gazeMap-map-fusion" [style.background-image]="'url(' + gazeMap.m.imagen + ')'">
      <img src="assets/images/grid.svg" class="gaze-map-grid-hidden">
    </div>
  </div>
  <div class="col-12 col-md-3"
    [ngClass]="{'col-fusion':gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion'}">

    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay !='Fusion'" class="gazeMap-map"
      [style.background-image]="'url(' + gazeMap.s.imagen + ')'">
      <img src="assets/images/grid.svg" class="gaze-map-grid-hidden">
    </div>
    <div *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' "
      class="gazeMap-map gazeMap-map-office" alt="Gaze Map" style="visibility:hidden">
      <img src="assets/images/halo.png">
    </div>
    <h3
      [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      {{ 'MIMESYS.NEAR_PLANE' | translate }}</h3>
    <ul class="list-group list-group-flush" [ngClass]="{'list-group-creating-pdf':whileCreatingPdf}"
      [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.gazeType" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.s.classification.tipo_mirada }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.amplitudeRatio" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.s.classification.amplitud }}</span>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.maxFrequencyVector" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.s.classification.frequency }}</span>
      </li>
      <li *ngIf="!viewRawData && gazeMapService.currentGazeMapSettingsValue.settings!.diagnostic" class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.s.classification.diagnostic }}</p>
      </li>
    </ul>
    <div
      *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.mapsDisplay =='Fusion' && gazeMapService.currentGazeMapSettingsValue.settings!.additionalMapsDisplay =='All'"
      class="gazeMap-map gazeMap-map-fusion" [style.background-image]="'url(' + gazeMap.s.imagen + ')'">
      <img src="assets/images/grid.svg" class="gaze-map-grid-hidden">
    </div>
  </div>
</div>

<div id="gaze-map-containter-to-pdf-bi-fold-brochure-office" class="row p-4"
  *ngIf="gazeMap && !gazeMap.l && gazeMapService.currentGazeMapSettingsValue.settings?.template=='Bi-fold-brochure'"
  [ngClass]="{'pdfStylingDiv':whileCreatingPdf}">
  <div id="gaze-map-containter-to-pdf-extra-info">
    <ul
      [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      <li
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <div
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          Code:</div>
        <div>{{gazeMap!.m.testId!}}</div>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.shortTestID"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <div
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          Short Test ID:</div>
        <div>{{gazeMap!.m.alias}}</div>
      </li>
      <li
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <div
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          Date:</div>
        <div>{{gazeMap.s.created_at_non_utc  | date:'yyyy/MM/dd HH:mm' }}</div>
      </li>
      <li
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <div
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          Reference:</div>
        <div>{{displayValue}}</div>
      </li>
    </ul>
  </div>
  <div class="col-3">
    <h3
      [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      {{''}}
    </h3>
    <div class="gazeMap-map gazeMap-map-office" alt="Gaze Map" style="visibility:hidden;height: 312px;">
      <img src="assets/images/halo.png" class="gaze-map-halo-hidden">
    </div>
    <ul
      [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
      class="list-group list-group-office list-group-flush">
      <!--*ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.gazeType" -->
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <!--<img src="assets/images/icons/gaze-type.svg">-->
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="22" viewBox="6 0 22 22" fill="none">
          <path d="M11.7091 0.5L1.5 10.952L11.7091 21.404"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path
            d="M9.22852 2.89722C11.2572 5.007 12.3912 7.82624 12.3912 10.7602C12.3912 13.6941 11.2572 16.5134 9.22852 18.6232"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path
            d="M17.2925 0.5C19.9921 3.32222 21.4999 7.0851 21.4999 11C21.4999 14.9148 19.9921 18.6777 17.2925 21.4999"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path
            d="M12.2811 13.445C11.6738 13.445 11.0913 13.2025 10.6619 12.771C10.2325 12.3394 9.99121 11.754 9.99121 11.1436C9.99121 10.5333 10.2325 9.94793 10.6619 9.51634C11.0913 9.08475 11.6738 8.84229 12.2811 8.84229"
            [ngStyle]="{'fill': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}" />
          <path d="M17.2925 18.8152V21.5001H19.7732"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path d="M19.7732 0.5H17.2925V3.08903"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
        </svg> <span
          [ngStyle]="{'color':(whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">{{
          'MIMESYS.GAZE_TYPE' |
          translate }}</span>
      </li>
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <!--<img src="assets/images/icons/amplitude-ratio.svg">-->
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="4 0 24 24" fill="none">
          <g clip-path="url(#clip0_1137_87727)">
            <path
              d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" />
            <path
              d="M18.7999 20.5999C11.1999 19.9999 8.4999 16.9999 3.3999 18.7999C3.9999 11.1999 6.9999 8.4999 5.1999 3.3999C12.7999 3.9999 15.4999 6.9999 20.5999 5.1999C19.9999 12.7999 16.9999 15.4999 18.7999 20.5999Z"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-linejoin="round" />
            <path d="M12.0002 1C18.2002 14.5 5.80024 9.5 12.0002 23"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" />
            <path d="M1 12C14.5 5.79999 9.5 18.2 23 12"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" />
          </g>
          <defs>
            <clipPath id="clip0_1137_87727">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">{{
          'MIMESYS.VERTICAL_FLECTION_RATIO' | translate
          }}</span>
      </li>
      <!--*ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.maxFrequencyVector" -->
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <!--<img src="assets/images/icons/max-freq-vector.svg">-->
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="4 0 24 24" fill="none">
          <path
            d="M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path d="M12 1V23"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path d="M1 12H23"
            [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path d="M14.7002 9.3999H9.2002V14.8999H14.7002V9.3999Z"
            [ngStyle]="{'fill': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}" />
        </svg> <span
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">{{
          'MIMESYS.MAX_FREQUENCY_VECTOR' | translate
          }}</span>
      </li>
      <!--&& gazeMapService.currentGazeMapSettingsValue.settings!.diagnostic-->
      <li class="list-group-item" *ngIf="!viewRawData"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <!--<img src="assets/images/icons/diagnostic.svg">-->
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="4 0 24 24" fill="none">
          <g clip-path="url(#clip0_1137_87723)">
            <path d="M1 10.9H3.6L6.2 4.30005L9.7 17L11.1 10.6H21"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M19.1 1H2.9C1.85066 1 1 1.85066 1 2.9V19.1C1 20.1493 1.85066 21 2.9 21H19.1C20.1493 21 21 20.1493 21 19.1V2.9C21 1.85066 20.1493 1 19.1 1Z"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" stroke-linecap="round" />
            <path
              d="M19 24C21.7614 24 24 21.7614 24 19C24 16.2386 21.7614 14 19 14C16.2386 14 14 16.2386 14 19C14 21.7614 16.2386 24 19 24Z"
              [ngStyle]="{'fill': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}" />
            <path d="M16.7002 18.9999L18.2002 20.8999L21.3002 17.3999" stroke="white" stroke-miterlimit="10"
              stroke-linecap="round" />
          </g>
          <defs>
            <clipPath id="clip0_1137_87723">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg><span
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">{{
          'MIMESYS.DIAGNOSTIC' | translate }}</span>
      </li>
    </ul>
  </div>
  <div class="col-4">
    <h3
      [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      {{ 'COMMON.GAZE_TITLE' | translate }}</h3>
    <div class="gazeMap-map gazeMap-map-office" [style.background-image]="'url(' + gazeMap.common.image + ')'"
      alt="Gaze Map">
      <img src="assets/images/halo.png" class="gaze-map-halo">
    </div>

    <ul
      [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
      class="list-group list-group-office list-group-flush">
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{
          gazeMap.common.classification.tipo_mirada }}</span>
      </li>
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.common.classification.vertical_flection_ratio }}</span>
      </li>
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.common.classification.frequency }}</span>
      </li>
      <!-- && gazeMapService.currentGazeMapSettingsValue.settings!.diagnostic-->
      <li class="list-group-item" *ngIf="!viewRawData"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.common.classification.diagnostic }}</p>
      </li>
    </ul>
  </div>
  <div class="col-5">
    <h3
      [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      {{ 'COMMON.WORKSPACE_TITLE' | translate }}</h3>
    <div class="gazeMap-map gaze-map-desktop " [ngClass]="{'gaze-map-desktop-non-admin':user.role?.id != 1}"
      alt="Gaze Map" [style.background-image]="'url(' + transform(lensOfficePrefix + gazeMap.common.desktop_image ) + ')'"><!-- -->
      <!--<img [src]="transform(gazeMap.common.desktop_image)">-->
    </div>
    <ul
      [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
      class="list-group list-group-office list-group-flush">
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <!--<img src="assets/images/icons/diagnostic.svg">-->
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="4 0 24 24" fill="none">
          <g clip-path="url(#clip0_1137_87723)">
            <path d="M1 10.9H3.6L6.2 4.30005L9.7 17L11.1 10.6H21"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M19.1 1H2.9C1.85066 1 1 1.85066 1 2.9V19.1C1 20.1493 1.85066 21 2.9 21H19.1C20.1493 21 21 20.1493 21 19.1V2.9C21 1.85066 20.1493 1 19.1 1Z"
              [ngStyle]="{'stroke': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" stroke-linecap="round" />
            <path
              d="M19 24C21.7614 24 24 21.7614 24 19C24 16.2386 21.7614 14 19 14C16.2386 14 14 16.2386 14 19C14 21.7614 16.2386 24 19 24Z"
              [ngStyle]="{'fill': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}" />
            <path d="M16.7002 18.9999L18.2002 20.8999L21.3002 17.3999" stroke="white" stroke-miterlimit="10"
              stroke-linecap="round" />
          </g>
          <defs>
            <clipPath id="clip0_1137_87723">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg><span
          [ngStyle]="{'color': (whileCreatingPdf  && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">{{
          'MIMESYS.ERGONOMY' | translate }}</span>
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.common.classification.ergonomy }}</p>
      </li>
    </ul>
  </div>
</div>

<!-- Bi-fold Brochure - Single Vision -->
<div id="gaze-map-containter-to-pdf-bi-fold-brochure-svision" class="row p-4"
  *ngIf="gazeMap && gazeMap.l && gazeMap.s && gazeMap.s.aplicacion_name=='svision' && whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings?.template=='Bi-fold-brochure'"
  [ngClass]="{'pdfStylingDiv':whileCreatingPdf}">
  <!-- Page 1 - Same as Progressive/Office -->
  <div id="gaze-map-containter-to-pdf-extra-info">
    <ul
      [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      <li
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <div
          [ngStyle]="{'color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          Code:</div>
        <div>{{gazeMap!.s.testId}}</div>
      </li>
      <li *ngIf="gazeMapService.currentGazeMapSettingsValue.settings!.shortTestID"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <div
          [ngStyle]="{'color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          Short Test ID:</div>
        <div>{{gazeMap!.s.alias}}</div>
      </li>
      <li
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <div
          [ngStyle]="{'color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          Date:</div>
        <div>{{gazeMap.s.created_at_non_utc | date:'YYYY/MM/dd HH:mm' }}</div>
      </li>
      <li
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <div
          [ngStyle]="{'color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          Reference:</div>
        <div>{{displayValue}}</div>
      </li>
    </ul>
  </div>

  <!-- Page 2 - Single Vision Map centered with columns below -->
  <div class="col-12 text-center mb-4">
    <div class="d-flex justify-content-center">
      <div class="svision-map-container">
        <div class="gazeMap-map gazeMap-map-svision"
             [style.background-image]="'url(' + gazeMap.common.image + ')'"
             alt="Single Vision Gaze Map">
          <img src="assets/images/halo.png" class="gaze-map-halo-svision">
        </div>
      </div>
    </div>
  </div>

  <!-- Column labels section -->
  <div class="col-12 col-md-4">
    <h3>&nbsp;</h3>
    <ul class="list-group list-group-flush"
      [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="22" viewBox="6 0 22 22" fill="none">
          <path d="M11.7091 0.5L1.5 10.952L11.7091 21.404"
            [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path
            d="M9.22852 2.89722C11.2572 5.007 12.3912 7.82624 12.3912 10.7602C12.3912 13.6941 11.2572 16.5134 9.22852 18.6232"
            [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path
            d="M17.2925 0.5C19.9921 3.32222 21.4999 7.0851 21.4999 11C21.4999 14.9148 19.9921 18.6777 17.2925 21.4999"
            [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path
            d="M12.2811 13.445C11.6738 13.445 11.0913 13.2025 10.6619 12.771C10.2325 12.3394 9.99121 11.754 9.99121 11.1436C9.99121 10.5333 10.2325 9.94793 10.6619 9.51634C11.0913 9.08475 11.6738 8.84229 12.2811 8.84229"
            [ngStyle]="{'fill': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}" />
          <path d="M17.2925 18.8152V21.5001H19.7732"
            [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path d="M19.7732 0.5H17.2925V3.08903"
            [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
        </svg>
        <span
          [ngStyle]="{'color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          {{ 'MIMESYS.GAZE_TYPE' | translate }}
        </span>
      </li>
      
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="4 0 24 24" fill="none">
          <g clip-path="url(#clip0_1137_87727)">
            <path
              d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
              [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" />
            <path
              d="M18.7999 20.5999C11.1999 19.9999 8.4999 16.9999 3.3999 18.7999C3.9999 11.1999 6.9999 8.4999 5.1999 3.3999C12.7999 3.9999 15.4999 6.9999 20.5999 5.1999C19.9999 12.7999 16.9999 15.4999 18.7999 20.5999Z"
              [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-linejoin="round" />
            <path d="M12.0002 1C18.2002 14.5 5.80024 9.5 12.0002 23"
              [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" />
            <path d="M1 12C14.5 5.79999 9.5 18.2 23 12"
              [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" />
          </g>
        </svg>
        <span
          [ngStyle]="{'color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          {{ 'MIMESYS.AMPLITUDE_RATIO' | translate }}
        </span>
      </li>
      
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="4 0 24 24" fill="none">
          <path
            d="M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z"
            [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path d="M12 1V23"
            [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path d="M1 12H23"
            [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
            stroke-miterlimit="10" />
          <path d="M14.7002 9.3999H9.2002V14.8999H14.7002V9.3999Z"
            [ngStyle]="{'fill': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}" />
        </svg>
        <span
          [ngStyle]="{'color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          {{ 'MIMESYS.MAX_FREQUENCY_VECTOR' | translate }}
        </span>
      </li>
      
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="4 0 24 24" fill="none">
          <g clip-path="url(#clip0_1137_87723)">
            <path d="M1 10.9H3.6L6.2 4.30005L9.7 17L11.1 10.6H21"
              [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M19.1 1H2.9C1.85066 1 1 1.85066 1 2.9V19.1C1 20.1493 1.85066 21 2.9 21H19.1C20.1493 21 21 20.1493 21 19.1V2.9C21 1.85066 20.1493 1 19.1 1Z"
              [ngStyle]="{'stroke': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}"
              stroke-miterlimit="10" stroke-linecap="round" />
            <path
              d="M19 24C21.7614 24 24 21.7614 24 19C24 16.2386 21.7614 14 19 14C16.2386 14 14 16.2386 14 19C14 21.7614 16.2386 24 19 24Z"
              [ngStyle]="{'fill': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}" />
            <path d="M16.7002 18.9999L18.2002 20.8999L21.3002 17.3999" stroke="white" stroke-miterlimit="10"
              stroke-linecap="round" />
          </g>
        </svg>
        <span
          [ngStyle]="{'color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
          {{ 'MIMESYS.DIAGNOSTIC' | translate }}
        </span>
      </li>
    </ul>
  </div>

  <!-- Far Plane Column -->
  <div class="col-12 col-md-4">
    <h3
      [ngStyle]="{'color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      {{ 'MIMESYS.FAR_PLANE' | translate }}
    </h3>
    <ul class="list-group list-group-flush"
      [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.l.classification.tipo_mirada }}</span>
      </li>
      
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.l.classification.amplitud }}</span>
      </li>
      
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.l.classification.frequency }}</span>
      </li>
      
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.l.classification.diagnostic }}</p>
      </li>
    </ul>
  </div>

  <!-- Near Plane Column -->
  <div class="col-12 col-md-4">
    <h3
      [ngStyle]="{'color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      {{ 'MIMESYS.NEAR_PLANE' | translate }}
    </h3>
    <ul class="list-group list-group-flush"
      [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
      
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.s.classification.tipo_mirada }}</span>
      </li>
      
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.s.classification.amplitud }}</span>
      </li>
      
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <span class="float-end">{{ gazeMap.s.classification.frequency }}</span>
      </li>
      
      <li class="list-group-item"
        [ngStyle]="{'border-color': (whileCreatingPdf && gazeMapService.currentGazeMapSettingsValue.settings!.template == 'Bi-fold-brochure')? gazeMapService.currentGazeMapSettingsValue.settings?.color!:stroke}">
        <p [ngClass]="{'lan-right':reverse_lan_dir()}">{{ gazeMap.s.classification.diagnostic }}</p>
      </li>
    </ul>
  </div>
</div>


<span *ngIf="configSvc.currentConfigValue.debug">{{ 'vertical_reflection_ratio.diagnostic.panoramic_low_vrr' |
  translateMimesys}}</span>
<hbo-corridor-modal *ngIf="gazeMap?.m && gazeMapService.currentGazeMapSettingsValue.settings"
  (confirm)="initializeCorridor()" [entity]="null" [gazeMap]="gazeMap.m"
  [img]="gazeMapService.currentGazeMapSettingsValue.settings.appFrontendDesign.ergoCorridorLogo?.logoImage!"
  [ergoData]="ergoData" [action]="action"></hbo-corridor-modal>